import { store, getElement, getContext } from '@wordpress/interactivity';
import { INTERACTIVITY_STORE_NAME } from '../../editor/settings';

const { state, actions } = store(INTERACTIVITY_STORE_NAME, {
  state: {
    get buttonAriaLabel() {
      const context = getContext();
      const comparator = context.isDailySummary ? state?.isPlayingDailySummary : context?.isPlaying;

      return comparator ? context.pauseButtonAriaLabel : context.playButtonAriaLabel;
    },
  },
  actions: {
    handleButtonClick: () => {
      const context = getContext();

      if (state.playingAudioId !== context.id) {
        actions.handleStop();
      }

      const isPlayingAudio = context.isPlaying || state.isPlayingDailySummary;

      if (isPlayingAudio && state.playingAudioId) {
        context.audioPlayerRef.pause();
      } else {
        context.audioPlayerRef.play();
      }
    },
    handlePlay: () => {
      const context = getContext();
      state.playingAudioId = context.id;

      if (context.isDailySummary) {
        state.isPlayingDailySummary = true;
      } else {
        context.isPlaying = true;
      }
    },
    handlePause: () => {
      const context = getContext();
      state.playingAudioId = null;

      if (context.isDailySummary) {
        state.isPlayingDailySummary = false;
      } else {
        context.isPlaying = false;
      }
    },
    handleStop: (event) => {
      // Handle audio tracks that have ended or that were stopped by the user (start playing a new track whilst one was playing).
      if (event?.target || state.playingAudioId) {
        const currentlyPlayingAudioElement =
          event?.target || document.querySelector(`audio#${state.playingAudioId}`);
        currentlyPlayingAudioElement.pause();
        currentlyPlayingAudioElement.currentTime = 0;
        state.playingAudioId = null;
        return;
      }

      /// Ensure we stop all paused audio tracks when we start playing a new one.
      const context = getContext();
      const audioElements = [...document.querySelectorAll('audio')].filter(
        (audio) =>
          audio !== context.audioPlayerRef &&
          audio.id.includes('lana-ai-audio') &&
          audio.currentTime > 0,
      );
      audioElements.forEach((audio) => {
        audio.pause();
        audio.currentTime = 0;
      });
      state.playingAudioId = null;
    },
  },
  callbacks: {
    /**
     * Allows multiple daily summary blocks to control the same audio element (the first to be rendered).
     *
     * @return {void}
     */
    onInit: () => {
      const context = getContext();
      const { ref } = getElement();
      context.audioPlayerRef = ref?.querySelector('audio');

      if (!context.isDailySummary) {
        return;
      }

      if (state.dailySummaryAudioPlayerRef) {
        context.audioPlayerRef = state.dailySummaryAudioPlayerRef;
        return;
      }

      context.src = context.audioFileUrl;
      state.dailySummaryAudioPlayerRef = context.audioPlayerRef;
    },
  },
});
